import React from 'react';
import PropTypes from 'prop-types';

import {
  Condition,
  SelectAssignment,
  SelectTeam,
  SelectTeamMember,
  SelectUserLookUp,
} from '../../../../../../common';
import {
  TASK_ASSIGN_TO_FIELDS,
  TASK_FIELDS,
  TEAM_FIELDS,
} from '../../../../../../../constants';

const RenderSelectAssignmentSection = ({
  change,
  getTeams,
  values,
  stripes,
  teams,
  getUsers,
  users,
  isUsersLoaded,
}) => (
  <>
    <SelectAssignment
      change={change}
      getTeams={getTeams}
    />

    <Condition
      is={TASK_ASSIGN_TO_FIELDS.USER}
      when={values[TASK_FIELDS.ASSIGN_TO]}
    >
      <SelectUserLookUp
        change={change}
        stripes={stripes}
      />
    </Condition>

    <Condition
      is={TASK_ASSIGN_TO_FIELDS.TEAM}
      when={values[TASK_FIELDS.ASSIGN_TO]}
    >
      <SelectTeam
        change={change}
        getUsers={getUsers}
        teams={teams}
      />
    </Condition>

    { values[TASK_FIELDS.TEAM]?.[TEAM_FIELDS.ID] && (
      <SelectTeamMember
        change={change}
        isTeamMembersLoaded={isUsersLoaded}
        teamMembers={users}
      />
    )}
  </>
);

RenderSelectAssignmentSection.propTypes = {
  change: PropTypes.func.isRequired,
  getTeams: PropTypes.func.isRequired,
  getUsers: PropTypes.func.isRequired,
  isUsersLoaded: PropTypes.bool.isRequired,
  stripes: PropTypes.shape({
    user: PropTypes.shape({
      user: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  teams: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
  users: PropTypes.array,
};

RenderSelectAssignmentSection.defaultProps = {
  users: null,
};

export default RenderSelectAssignmentSection;
